import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const Logo = ({ imageUrl, logoClass }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    checkMobile();
    window.addEventListener("resize", checkMobile);
    
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <div className={clsx(logoClass)} style={{ 
      padding: 0, 
      display: "flex", alignItems: "center", height: "100%", marginTop: "-8px" 
    }}>
      <Link to={process.env.PUBLIC_URL + "/"} style={{ padding: 0 }}>
        <img 
          alt="" 
          src={imageUrl.startsWith("http") ? imageUrl : process.env.PUBLIC_URL + imageUrl} 
          onError={(e) => {
            console.error("로고 이미지 로드 오류");
            e.target.src = process.env.PUBLIC_URL + "/assets_flone/img/logo/logo.png"; // 기본 이미지로 대체
          }}
          style={{
            // maxHeight: "60px", // 헤더 높이에 맞춰 최대 높이 더 줄임
            maxWidth: "100%", // 컨테이너 너비를 넘지 않도록 설정
            objectFit: "contain", // 이미지 비율 유지
            padding: "10px",
            margin: 0,
            maxHeight: isMobile ? "70px" : "90px",
            display: "inline-block",
            verticalAlign: "middle",
            marginTop: "5px"

          }}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string
};

export default Logo;
